 class Experiences {
  static experiences(value:any) {
    const data:any = [{
      title: 'Pre-Recorded Content',
      icon: 'pre-recorded.svg',
      activeIcon: 'pre-recorded2.svg',
      description: '(Select 1 or multiple)',
      children: []
    },
    {
      title: 'Live Experiences',
      icon: 'live.svg',
      activeIcon: 'live2.svg',
      description: '(Select 1 or multiple)',
      children: []
    }
  ]
  if(value && value.async && value.async.length){
    for (const obj of value.async){
      const subItems:any = []
      if(obj.subcategories && obj.subcategories.length){
          for (const sub of obj.subcategories){
            subItems.push({
            icon:sub.icon_url,
            title:sub.display_subcategory,
            name:sub.subcategory
          })
        }
      }
      const asyncCategories = {
        id:obj.cat_subcat_id,
        icon:obj.icon_url,
        title:obj.display_category,
        description:"",
        name:obj.category,
        subItems:subItems
      }
      data[0].children.push(asyncCategories)
    }
  }
  if(value && value.moderated && value.moderated.length){

    for (const obj of value.moderated){
      const subItems:any = []
      if(obj.subcategories && obj.subcategories.length){
        for (const sub of obj.subcategories){
          subItems.push({
            icon:sub.icon_url,
            title:sub.display_subcategory,
            name:sub.subcategory
          })
        }
      }
      const moderatedCategories = {
        id:obj.cat_subcat_id,
        icon:obj.icon_url,
        title:obj.display_category,
        description:"",
        name:obj.category,
        subItems:subItems
      }
      data[1].children.push(moderatedCategories)
    }
  }
  return data
  }
}

export default Experiences